<template>
    <!-- 更新索引 -->
    <!-- 表格组件 -->
      <el-table
          class="table"
          ref="multipleTableRef"
          :data="tableData"
          :height="tableHeight"
          border
          stripe 
          :header-cell-style="{ background: '#f5f7fa' }"
          style="width: 100%; margin-top: 10px"
          v-loading="loading"
          element-loading-text="更新中"
        >
          <el-table-column
            prop="name"
            label="名称"
            align="left"
            fixed="left">
          </el-table-column>
          <el-table-column
                label="操作"
                width="200px"
                align="center">
                <template #default="scope">
                <el-button  type="primary"  size="default" plain @click="releaseFnc(scope.row)">更新</el-button>
                </template>
              </el-table-column>
        </el-table>
</template>

<script>
import { reactive, toRefs,h } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { UpdateArticleIndex, UpdateMajorIndex, UpdateSchoolIndex,UpdateSchoolAndMajorIndex } from "network/updateIndex.js";
export default {
    name: "UpdateIndex",
    props: {
        tableMaxHeight: Number,
    },
    setup() {
        //这里定义一个结构体，用来保存项目信息
        const data = reactive({
            //表格数据
            tableData: [{
                name: '文章索引',
                  id:1
            }, {
                name: '非普本院校索引',
                  id: 2
            }, {
                name: '非普本专业索引',
                  id: 3
            },{
                name: '普本院校和专业索引',
                  id: 4
            }
        ],
        loading:false, //加载中
        });
        //发布
        const releaseFnc = (e) => {
               ElMessageBox({
                title: "更新",
                message: h("p", null, [
                    h("span", null, "是否更新【"),
                    h(
                        "b",
                        { style: "color: #fd5252;font-size:16px;" },
                        `${e.name}`
                    ),
                    h("span", null, "】？ "),
                ]),
                showCancelButton: true,
                cancelButtonText: "取消",
                confirmButtonText: "确认",
                beforeClose: (action, instance, done) => {
                    if (action === "confirm") {
                        // 开启按钮加载
                        instance.confirmButtonLoading = true;
                        instance.confirmButtonText = "确认中",
                        // 删除接口
                        done();
                        postHtml(e.id);
                        
                    } else {
                        done();
                    }
                },
            })
                // .then(() => {
                //     postHtml(e.id);
                // })
                .catch(() => {
                    ElMessage("取消更新");
                });
        };
        const postHtml = async (id) => {
            data.loading = true
            let result = {};
            if(id == 1 ){
               result = await UpdateArticleIndex();
            }else if(id ==2){ 
                result = await UpdateSchoolIndex();
            }else if (id == 3) {
                result = await UpdateMajorIndex();
            }else if (id==4){
                result = await UpdateSchoolAndMajorIndex();
            }
            if (result.code == 1) {
                ElMessageBox.alert(result.message, "更新", {
                    confirmButtonText: "确定",
                });
            } else {
                ElMessageBox.alert(result.message, "更新", {
                    confirmButtonText: "确定",
                });
            }
            data.loading = false
        };
        return {
            //解构Data结构体，让模板可以直接调用Data里面的对象
            ...toRefs(data),
            releaseFnc,
        };
    },
};
</script>


